export enum ProductEdition {
    Core = 'Core',
    Ignite = 'Ignite',
    Engage = 'Engage',
    Express = 'Express'
}
